import { List, Root } from "@radix-ui/react-navigation-menu";
import { useTranslation } from "react-i18next";

import Card from "../ui/Card";
import NavigationLink from "./NavigationLink";

function Navigation() {
  const { t } = useTranslation(["trajectory"]);

  return (
    <Card className="mb-sm py-sm">
      <Root orientation="horizontal">
        <List className="gap-x-sm flex">
          <NavigationLink href="/trajectory/action-plan">
            {t("trajectory:pages.trajectory")}
          </NavigationLink>
          <NavigationLink href="/trajectory/projections">
            {t("trajectory:pages.projections")}
          </NavigationLink>
          <NavigationLink href="/trajectory/context">
            {t("trajectory:pages.context")}
          </NavigationLink>
        </List>
      </Root>
    </Card>
  );
}

export default Navigation;
